import { IBaseProps } from '../types';
import { CustomerDetailType } from '../../CustomerTab/types';
import React, { useEffect, useMemo, useState } from 'react';
import useForm from '../useForm';
import style from '../style.module.css';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FlagPhonePickerValidationHelper from 'external-components/flag-phone-picker-react/FlagPhonePickerValidationHelper';
import PhoneNumberService from 'external-services/phone-number-service';
import { withStyles } from '@material-ui/core';
import { APP_COLORS, Colors } from 'design-v2/globals/colors/colors';
import Switch from '@material-ui/core/Switch';
import AdminService from 'external-services/diary-admin-service/admin.service';
import classNames from 'classnames';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import EmailIcon from '@material-ui/icons/Email';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
// import { IBookedByCustomerDetail } from 'shared-types';

const NARROW_LAYOUT = `'first last' 'phone phone' 'email company' 'comm comm'`;
const WIDE_LAYOUT = `'first last company' 'phone email comm'`;
const EMPTY_OBJ = {} as any;
const classPrefixStyle = 'BookedByForm';

/**
 * Note: This component is for the Legacy Diary Edit Booking Dialog only.
 * For Diary Mobile and new Diary, use BookedByForBookingCreator.tsx
 */

const BookedByForEditBooking = (props: IBaseProps) => {
  const {
    customer = EMPTY_OBJ,
    handleChange,
    country,
    setErrors,
    layout = 'narrow',
    mode = 'new',
    isBookedBy = false,
    enableEmailSmsNotification = false, // For Edit mode only, ‘Resend Email Confirmation’ and ‘Resend SMS Confirmation’ only appear when the status of the booking is Confirmed or unconfirmed.
    triggerBookedByValidation, // if it's 0, it's not triggered, otherwise it's triggered
    toggleBookedByWithEditBooking, //trigger bookedBy in edit booking
    isNoPayment, // if no payment, user able to delete bookedBY info and toggle off bookedBy, otherwise, user can't delete bookedBy info then toggle off
    classPrefixBookedBy,
    isBookingLocked, // if booking is locked, disable booked by toggle on edit booking,
    isSurnameRequired,
    titleSubscription,
  } = props;

  const classPrefix = classPrefixBookedBy || classPrefixStyle;
  const CssTextField = useMemo(
    () =>
      withStyles({
        root: {
          [`& .Mui-error`]: {
            fontSize: '12px',
          },
          [`& .${classPrefix ? classPrefix + '-' : ''}MuiFormHelperText-root`]: {
            fontFamily: 'Roboto, Helvetica Neue, sans-serif',
            letterSpacing: '0',
          },
          [`& .${classPrefix ? classPrefix + '-' : ''}MuiInputBase-root`]: {
            fontFamily: 'Roboto, Helvetica Neue, sans-serif',
            fontSize: '16px',
          },
          [`& .${classPrefix ? classPrefix + '-' : ''}MuiInputLabel-shrink`]: {
            color: 'rgba(0, 0, 0, 0.6)',
          },
          [`& .${classPrefix ? classPrefix + '-' : ''}MuiInput-underline:before`]: {
            borderWidth: '1px !important',
            borderColor: 'rgba(0,0,0,0.12) !important',
          },
          [`& .${classPrefix ? classPrefix + '-' : ''}MuiInput-underline.Mui-error:after`]: {
            borderBottomColor: 'rgba(0, 0, 0, 0.03)',
          },
          [`& .${
            classPrefix ? classPrefix + '-' : ''
          }MuiInput-underline.Mui-error.Mui-focused:after`]: {
            borderBottomColor: Colors.get(APP_COLORS.clrNbiMagenta),
          },
          [`& .${classPrefix ? classPrefix + '-' : ''}MuiFormLabel-root.Mui-focused`]: {
            color: Colors.get(APP_COLORS.clrNbiMagenta),
          },
          [`& .${classPrefix ? classPrefix + '-' : ''}MuiFormLabel-root.Mui-error`]: {
            color: 'rgba(0, 0, 0, 0.6)',
          },
        },
      })(TextField),
    []
  );

  const {
    values: bookedCus,
    setValue,
    errors,
  } = useForm(customer, triggerBookedByValidation, handleChange, isSurnameRequired);

  useEffect(() => {
    setErrors && setErrors(errors);
  }, [errors]);

  const { nationalNumber, country: countryFromPhoneNumer } = useMemo(() => {
    return customer?.phone
      ? PhoneNumberService.parseNumber(customer.phone, true)
      : {};
  }, [customer]);

  const [disableToggle, setDisableToggle] = useState(false);
  const [toggleOnBookedBy, setToggleOnBookedBy] = useState(isBookedBy);
  const toggleOnChangeHandler = (e: any) => {
    toggleBookedByWithEditBooking(e.target.checked);
    setToggleOnBookedBy(e.target.checked);
  };
  useEffect(() => {
    //if any of the fields have a value, disable the toggle
    const values = [
      bookedCus.phone,
      bookedCus.firstName,
      bookedCus.lastName,
      bookedCus.email,
      bookedCus.company,
      bookedCus.subscribed,
    ];
    setDisableToggle(values.filter((e) => !!e).length > 0);
  }, [bookedCus]);
  const isSmsEnabledInSetting = AdminService.getVenue().smsEnabled;

  return (
    <div className={style.customerTabContainer}>
      {mode === 'edit' ? (
        <div className={style.header}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={!!toggleOnBookedBy}
                onChange={toggleOnChangeHandler}
                name="isShown"
                disabled={disableToggle || !isNoPayment || isBookingLocked}
              />
            }
            label="Show booked by"
            className={style.bottomSpacer}
          />
          <div className={style.infoIcon}>
            <Tooltip title="This section is for the person/company making the booking if different to the customer details">
              <InfoIcon />
            </Tooltip>
          </div>
        </div>
      ) : null}
      {(toggleOnBookedBy && mode === 'edit') || mode === 'new' ? (
        <div
          style={{
            display: 'grid',
            gridGap: '12px',
            alignItems: 'stretch',
            gridTemplateAreas: layout === 'narrow' ? NARROW_LAYOUT : WIDE_LAYOUT,
            gridTemplateColumns: layout === 'narrow' ? '1fr 1fr' : '1fr 1fr 1fr',
            gridTemplateRows: layout === 'narrow' ? '1fr 1fr 1fr' : '1fr 1fr',
          }}
        >
          <div style={{ gridArea: 'first' }} className={style.input}>
            <div className={style.iconContainer}>
              <AccountBoxIcon />
            </div>
            <CssTextField
              error={Boolean(errors?.firstName)}
              fullWidth
              name="firstName"
              placeholder={'First Name'}
              helperText={errors?.firstName ? errors?.firstName : ' '}
              value={bookedCus?.firstName || ''}
              onChange={setValue}
            />
          </div>

          <div style={{ gridArea: 'last' }} className={style.input}>
            <div className={style.iconContainer}></div>
            <CssTextField
              error={Boolean(errors?.lastName)}
              fullWidth
              name="lastName"
              placeholder={'Surname'}
              helperText={errors?.lastName ? errors?.lastName : ' '}
              value={bookedCus?.lastName || ''}
              onChange={setValue}
            />
          </div>

          <div style={{ gridArea: 'company' }} className={style.input}>
            <div className={style.iconContainer}>
              <LocationCityIcon />
            </div>
            <CssTextField
              fullWidth
              name="company"
              placeholder={'Company'}
              helperText={errors?.company ? errors?.company : ' '}
              value={bookedCus?.company || ''}
              onChange={setValue}
            />
          </div>

          <div style={{ gridArea: 'phone' }} className={style.phoneSection}>
            <FlagPhonePickerValidationHelper
              forceTouched={true}
              skipAutoComplete={true}
              customerCountry={isBookedBy ? countryFromPhoneNumer : country}
              validationError={errors?.phone}
              customerPhone={nationalNumber || ''}
              classPrefix={classPrefix}
              handlePhoneChange={(value: string, phoneWithoutPrefix: string) => {
                setValue({
                  target: {
                    name: CustomerDetailType.phone,
                    value,
                  },
                } as React.ChangeEvent<HTMLInputElement>);
              }}
              usePlaceholderForLabel={true}
              isDropDownListMoveUp={mode === 'new'}
            />
          </div>

          <div style={{ gridArea: 'email' }} className={style.input}>
            <div className={style.iconContainer}>
              <EmailIcon />
            </div>
            <CssTextField
              error={Boolean(errors?.email)}
              fullWidth
              name="email"
              placeholder={'Email'}
              helperText={errors?.email ? errors?.email : ' '}
              value={bookedCus?.email || ''}
              onChange={setValue}
            />
          </div>
          <div
            style={{ gridArea: 'comm' }}
            className={classNames({
              [style.communicationContainer]: mode !== 'edit',
              [style.fieldContainer]: true,
              [style.checkBoxContainer]: mode === 'edit',
            })}
          >
            <p className={style.communicationTitle}>Communication</p>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={!!bookedCus.subscribed}
                  onChange={setValue}
                  name="subscribed"
                />
              }
              label={<Typography style={{ fontSize: 12 }}>{titleSubscription}</Typography>}
              className={style.checkBoxContainer}
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={!!bookedCus.disableEmailSmsNotification}
                  onChange={setValue}
                  name="disableEmailSmsNotification"
                />
              }
              label={
                <Typography style={{ fontSize: 12 }}>
                  {!isSmsEnabledInSetting
                    ? 'Do not send emails to Booked By'
                    : 'Do not send emails or SMS to Booked By'}
                </Typography>
              }
              className={style.checkBoxContainer}
            />
          </div>
          {mode === 'edit' && enableEmailSmsNotification ? (
            <div style={{ gridArea: 'comm', marginTop: '80px' }}>
              {bookedCus.email && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      disabled={
                        bookedCus.disableEmailSmsNotification || !bookedCus.email || !!errors?.email
                      }
                      checked={
                        (bookedCus.notifyEmail && !bookedCus.disableEmailSmsNotification) || false
                      }
                      onChange={setValue}
                      name="notifyEmail"
                    />
                  }
                  label={
                    <Typography style={{ fontSize: 12 }}>
                      Resend email confirmation to Booked By
                    </Typography>
                  }
                  className={style.checkBoxContainer}
                />
              )}
              {bookedCus.phone && isSmsEnabledInSetting && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      disabled={
                        bookedCus.disableEmailSmsNotification || !bookedCus.phone || !!errors?.phone
                      }
                      checked={
                        (bookedCus.notifySms && !bookedCus.disableEmailSmsNotification) || false
                      }
                      onChange={setValue}
                      name="notifySms"
                    />
                  }
                  label={
                    <Typography style={{ fontSize: 12 }}>
                      Resend SMS confirmation to Booked By
                    </Typography>
                  }
                  className={style.checkBoxContainer}
                />
              )}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};
export default BookedByForEditBooking;
